var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-tabs',{attrs:{"tab-refs":_vm.tabRefs},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('rkm-tab',{attrs:{"title":"Dispensação"}},[_c('Dispensacao',{ref:"Dispensacao",attrs:{"data":_vm.data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }